import React from 'react';
import { BookOpen, Target, Users, Zap, Activity, Utensils, CloudRain, LifeBuoy, Calendar } from 'lucide-react';
export function ProductSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-court-night" data-id="element-192" data-mp="csa030wfr3fq">
      {/* SECTION 4 - SYSTEM PRESENTATION */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto text-center" data-id="element-193" data-mp="qjf3me2xcfvc">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-cyan-500/15 text-cyan-400 mb-6" data-id="element-194" data-mp="mimurlxysczl">
          <Target className="w-7 h-7" data-id="element-195" data-mp="10ie253tz6v4m" />
        </div>
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold text-white mb-4 leading-tight" data-id="element-196" data-mp="10frz9hi153sq">
          🏆 El Sistema N°1 para Profesores de Pádel
        </h2>
        <p className="text-base sm:text-xl text-slate-400 font-medium mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-197" data-mp="329r7ftzuv517">
          PADEL 360 — Colección Completa 12 Tomos + 6 Bonus — Todo resuelto,
          todos los niveles.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5" data-id="element-198" data-mp="1b79ldm68s3m">
          <StatBadge icon={<BookOpen className="w-5 h-5" data-id="element-200" data-mp="5d15l8lf97xg" />} text="+280 páginas" data-id="element-199" data-mp="1936uz00dz4x" />
          <StatBadge icon={<Activity className="w-5 h-5" data-id="element-202" data-mp="a40ym2rf75uo" />} text="+120 ejercicios graficados en cancha" data-id="element-201" data-mp="a3hj0sp8stjt" />
          <StatBadge icon={<Users className="w-5 h-5" data-id="element-204" data-mp="f2cbkmd0hwh4" />} text="Todos los niveles" data-id="element-203" data-mp="f1j23dmo4sva" />
          <StatBadge icon={<Zap className="w-5 h-5" data-id="element-206" data-mp="k3i6mqu59vtt" />} text='Sistema "Abre y Entra"' data-id="element-205" data-mp="k041xby0daj7" />
        </div>
      </section>

      {/* SECTION 5 - LOS 12 TOMOS */}
      <section className="py-20 bg-court-panel px-4 sm:px-6 lg:px-8 border-y border-white/5" data-id="element-207" data-mp="t12a86fhc47l">
        <div className="max-w-7xl mx-auto" data-id="element-208" data-mp="2qt6gpdbgpq1r">
          <div className="text-center mb-14" data-id="element-209" data-mp="2quhnzn449fxm">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold text-white mb-4" data-id="element-210" data-mp="2uurs0u8clw9u">
              Los <span className="text-cyan-400" data-id="element-211" data-mp="201dg6ypzg91">12 Tomos</span> Completos
            </h2>
            <p className="text-base sm:text-xl text-slate-400 font-medium" data-id="element-212" data-mp="3t6kx8bmjagjh">
              Drills graficados · Por nivel y objetivo · Listos para usar mañana
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-213" data-mp="6y353ga7onw4">
            <TomoCard num="1" title="Nivel Inicial — Fase 1" desc="El primer contacto real con la pala. Grip, posición, contacto y confianza desde el primer minuto." level="Inicial" accent="text-sky-400 bg-sky-500/10 border-sky-500/20" data-id="element-214" data-mp="kxklp8dcsuue" />
            <TomoCard num="2" title="Nivel Inicial — Fase 2" desc="Del peloteo al juego real. Globo defensivo, volea básica y primer contacto con la pared." level="Inicial" accent="text-sky-400 bg-sky-500/10 border-sky-500/20" data-id="element-215" data-mp="ppvnyhvkgsq4" />
            <TomoCard num="3" title="Intermedio 1 — Control y Posición" desc="Control direccional avanzado. Juego de fondo sistemático y movimiento de pareja sincronizado." level="Intermedio" accent="text-cyan-400 bg-cyan-500/10 border-cyan-500/20" data-id="element-216" data-mp="1iclukgwof9kf" />
            <TomoCard num="4" title="Intermedio 2 — Táctica de Pareja" desc="Sistema de red dominante. Coberturas, comunicación y cuándo bajar juntos de la red." level="Intermedio" accent="text-cyan-400 bg-cyan-500/10 border-cyan-500/20" data-id="element-217" data-mp="1de29eipwq1t4" />
            <TomoCard num="5" title="Avanzado 1 — Variantes Técnicas" desc="Bandeja, víbora, globo con efecto y remate por tres. El salto al juego de alto nivel." level="Avanzado" accent="text-violet-400 bg-violet-500/10 border-violet-500/20" data-id="element-218" data-mp="ulghg9i4evdt" />
            <TomoCard num="6" title="Avanzado 2 — Sistema de Juego Completo" desc="Sistema ofensivo completo. Lectura del rival, juego bajo presión y partido táctico dirigido." level="Avanzado" accent="text-violet-400 bg-violet-500/10 border-violet-500/20" data-id="element-219" data-mp="djan9tawg3e8" />
            <TomoCard num="7" title="Adultos Mayores — Fase 1" desc="Pádel adaptado para cuerpos maduros. Movilidad, equilibrio, seguridad y disfrute real de la cancha." level="Adultos" accent="text-amber-400 bg-amber-500/10 border-amber-500/20" data-id="element-220" data-mp="3vw8t2gudhqgb" />
            <TomoCard num="8" title="Adultos Mayores — Fase 2" desc="Juego de pareja adaptado, coordinación ojo-pala y torneo social seguro." level="Adultos" accent="text-amber-400 bg-amber-500/10 border-amber-500/20" data-id="element-221" data-mp="3czqupgl0qsb3" />
            <TomoCard num="9" title="Kids — Fase 1" desc="El pádel como juego. Coordinación, exploración lúdica y primer amor por la cancha." level="Kids" accent="text-pink-400 bg-pink-500/10 border-pink-500/20" data-id="element-222" data-mp="2t5zbzib8x2ru" />
            <TomoCard num="10" title="Kids — Fase 2" desc="Técnica lúdica y partido real con reglas adaptadas. El alumno que va a seguir jugando de grande." level="Kids" accent="text-pink-400 bg-pink-500/10 border-pink-500/20" data-id="element-223" data-mp="36wvz4tmekrri" />
            <TomoCard num="11" title="Lesiones — Prevención y Adaptación" desc="Protocolos para las 5 lesiones más comunes. Drills adaptados por zona y escalera de retorno al juego." level="Lesiones" accent="text-red-400 bg-red-500/10 border-red-500/20" data-id="element-224" data-mp="2j71l48qckx5o" />
            <TomoCard num="12" title="Lesiones — Casos Especiales y Alta Definitiva" desc="Posoperatorio, prótesis y patologías crónicas. El sistema para cuidar al alumno más fiel que tienes." level="Lesiones" accent="text-red-400 bg-red-500/10 border-red-500/20" data-id="element-225" data-mp="3eua57ot10e4" />
          </div>

          <div className="mt-14 flex flex-wrap justify-center gap-3" data-id="element-226" data-mp="24id9849lsoln">
            <BadgeItem icon="✏️" text="Ejercicios graficados en cada tomo" data-id="element-227" data-mp="1gt26ih8p0k4v" />
            <BadgeItem icon="⚡" text='Sistema "Abre y Entra"' data-id="element-228" data-mp="1gqzi21n6uz29" />
            <BadgeItem icon="📋" text="Fichas listas para imprimir" data-id="element-229" data-mp="1bv0m9szj6ert" />
            <BadgeItem icon="🌎" text="Contenido pensado para Latinoamérica" data-id="element-230" data-mp="1qilrptjvoq2w" />
          </div>

          {/* EXTRA CTA BUTTON */}
          <div className="mt-14 text-center" data-id="element-231" data-mp="1lr3wzn8g7lqd">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-slate-950 text-base sm:text-lg font-heading font-extrabold py-4 px-8 rounded-xl shadow-2xl shadow-cyan-500/25 transition-all hover:scale-[1.03] uppercase tracking-wide" data-id="element-232" data-mp="1lqc1sdirjq0m">
              Ver precio y acceso <Zap className="w-5 h-5" data-id="element-233" data-mp="39j4js73ovcs7" />
            </button>
          </div>
        </div>
      </section>

      {/* SECTION 6 - LOS 6 BONUS */}
      <section className="py-20 bg-court-night px-4 sm:px-6 lg:px-8 relative" data-id="element-234" data-mp="2zrguoculu7tw">
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-235" data-mp="2zpdux13nh0bz">
          <div className="text-center mb-12" data-id="element-236" data-mp="3nimawt4gj24q">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold text-white mb-4" data-id="element-237" data-mp="3sgferfiafk1u">
              + <span className="text-cyan-400" data-id="element-238" data-mp="3egwjhnaks36y">6 Regalos</span> Estratégicos
            </h2>
            <p className="text-base sm:text-lg text-slate-400 font-medium mb-7 max-w-md mx-auto" data-id="element-239" data-mp="3jfpmumw5edte">
              Incluidos sin costo extra · Valor real del pack
            </p>
            <div className="inline-flex items-center gap-2 bg-yellow-400 text-slate-950 font-heading font-extrabold px-6 py-3 rounded-full text-sm sm:text-base shadow-xl shadow-yellow-400/20 uppercase tracking-wide" data-id="element-240" data-mp="233kbr1bp30fi">
              🎁 Gratis por el día de hoy
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-241" data-mp="2unr6156cbnzp">
            <BonusCard num="1" icon={<Activity className="w-7 h-7" data-id="element-243" data-mp="2kr4nin1hl90u" />} title="NIVELÓMETRO 360" desc="Ubica a cualquier alumno en su nivel correcto en menos de 5 minutos. Nunca más adivines en qué tomo tiene que estar." data-id="element-242" data-mp="2pqhglpiybcbv" />
            <BonusCard num="2" icon={<Zap className="w-7 h-7" data-id="element-245" data-mp="38otprb9v4m7g" />} title="PREPARACIÓN FÍSICA DE 15 MINUTOS" desc="Rutinas específicas para el jugador de pádel. Sin gimnasio. Sin equipo. Solo tú, la cancha y el método." data-id="element-244" data-mp="3dgv0gsrdu4vd" />
            <BonusCard num="3" icon={<Utensils className="w-7 h-7" data-id="element-247" data-mp="51jmfsab43uo" />} title="NUTRICIÓN PARA EL JUGADOR DE PÁDEL" desc="Lo que comes decide el partido. Qué comer antes, durante y después. Sin dietas extremas. Sin suplementos caros." data-id="element-246" data-mp="50s3bgxwbyla" />
            <BonusCard num="4" icon={<CloudRain className="w-7 h-7" data-id="element-249" data-mp="hicbmpv5snds" />} title="PLAN PARA CUANDO LLUEVE" desc="La lluvia cancela la cancha, no la clase. 10 actividades de alto valor para el día que no hay cancha." data-id="element-248" data-mp="ckawuh4rna84" />
            <BonusCard num="5" icon={<LifeBuoy className="w-7 h-7" data-id="element-251" data-mp="qgy2r9ep5aq6" />} title="KIT DE SUPERVIVENCIA DEL PROFE" desc="Grupos mixtos sin aviso, sin materiales, con 20 minutos o alumnos de mal humor. Protocolo de emergencia para cualquier situación." data-id="element-250" data-mp="qjsod49g51l6" />
            <BonusCard num="6" icon={<Calendar className="w-7 h-7" data-id="element-253" data-mp="1a704p7m5gh1w" />} title="PACK DE ORGANIZACIÓN SEMANAL" desc="Plantillas para eliminar la ansiedad del domingo. Tus clases, pagos, materiales y pendientes en una sola hoja." data-id="element-252" data-mp="156ltjgp94qzn" />
          </div>
        </div>
      </section>
    </div>;
}
function StatBadge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center p-5 bg-white/[0.03] rounded-2xl border border-white/10" data-id="element-254" data-mp="1qnxwosfe57xc">
      <div className="w-10 h-10 rounded-xl bg-cyan-500/15 text-cyan-400 flex items-center justify-center mb-3" data-id="element-255" data-mp="20g3oo25n7pcj">
        {icon}
      </div>
      <p className="font-bold text-slate-200 text-sm sm:text-base leading-tight" data-id="element-256" data-mp="25e58ipaw7sp2">
        {text}
      </p>
    </div>;
}
function TomoCard({
  num,
  title,
  desc,
  level,
  accent
}: {
  num: string;
  title: string;
  desc: string;
  level: string;
  accent: string;
}) {
  return <div className="p-6 sm:p-7 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-white/20 hover:bg-white/[0.05] transition-all" data-id="element-257" data-mp="2jfhkyqquhc67">
      <div className="flex items-center justify-between mb-4" data-id="element-258" data-mp="k3onkt05a4sy">
        <span className="text-2xl font-heading font-extrabold text-white/25" data-id="element-259" data-mp="p05dnsqwmt8o">
          {num.padStart(2, '0')}
        </span>
        <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider border ${accent}`} data-id="element-260" data-mp="hiyyywuhxbuo">
          {level}
        </span>
      </div>
      <h3 className="text-base sm:text-lg font-heading font-bold text-white mb-2.5 leading-snug" data-id="element-261" data-mp="7snvtcimz6ou">
        {title}
      </h3>
      <p className="text-sm text-slate-400 leading-relaxed" data-id="element-262" data-mp="2ucnj67zp48q">{desc}</p>
    </div>;
}
function BadgeItem({
  icon,
  text
}: {
  icon: string;
  text: string;
}) {
  return <div className="flex items-center gap-2 bg-white/[0.04] px-4 py-2 rounded-full border border-white/10" data-id="element-263" data-mp="vi8h4229ig1a">
      <span data-id="element-264" data-mp="qgsva7s9g5hu">{icon}</span>
      <span className="font-semibold text-slate-300 text-xs sm:text-sm" data-id="element-265" data-mp="qg9eiuecjn5e">
        {text}
      </span>
    </div>;
}
function BonusCard({
  num,
  icon,
  title,
  desc
}: {
  num: string;
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return <div className="bg-white/[0.03] rounded-2xl p-6 sm:p-7 border border-white/10 hover:border-yellow-400/30 transition-all" data-id="element-266" data-mp="368yt5d4vt0ew">
      <div className="flex items-start justify-between mb-5" data-id="element-267" data-mp="1yaax1tprgjn7">
        <div className="w-12 h-12 rounded-xl bg-yellow-400/15 text-yellow-400 flex items-center justify-center" data-id="element-268" data-mp="22bwfdul2dq4s">
          {icon}
        </div>
        <span className="text-[11px] font-bold text-yellow-400 bg-yellow-400/10 border border-yellow-400/20 px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-269" data-mp="1obder8ixhmcn">
          Bonus {num} · Gratis
        </span>
      </div>
      <h3 className="text-base sm:text-lg font-heading font-bold text-white mb-2.5 leading-snug" data-id="element-270" data-mp="1ejz7ufondk9h">
        {title}
      </h3>
      <p className="text-sm text-slate-400 leading-relaxed" data-id="element-271" data-mp="15ldpakj6e58p">{desc}</p>
    </div>;
}